import {computed, makeObservable, observable} from "mobx";
import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {AbstractModel} from "./abstract-model";

export interface MunicipalityProps {
    objectId?: number;
    bfsNr?: number;
    name?: string;
    bfsName?: string;
}

@JsonObject()
export class Municipality extends AbstractModel {

    static readonly comparableAttributes: string[] = [
        "gemeinde", "bfsGemeinde"
    ];

    static readonly prototypeAttributes: string[] = [
        "objectid", "bfs_nr", "gemeinde", "bfs_gemeinde"
    ];

    static readonly databaseFieldNames: Map<string, string> = new Map<string, string>([
        ["objectId", "objectid"],
        ["bfsNr", "bfs_nr"],
        ["name", "gemeinde"],
        ["bfsName", "bfs_gemeinde"]
    ]);

    class = "Municipality";
    typeLabel = "Gemeinde";

    static sortByName(a: Municipality, b: Municipality) {
        const nameA = a.name;
        const nameB = b.name;
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }

        // names must be equal
        return 0;
    }

    static compare(a: Municipality, b: Municipality) {
        const nameA = a.name;
        const nameB = b.name;
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }

        // names must be equal
        return 0;
    }

    /**
     * !!! Use BFS Nr as guid !!!
     */
    @JsonProperty({name: "bfs_nr"})
        guid: string;

    @JsonProperty({name: "bfs_nr"})
        bfsNr: string;

    @JsonProperty({name: "gemeinde"})
        name: string;

    @JsonProperty({name: "bfs_gemeinde"})
        bfsName: string;

    constructor(props: MunicipalityProps) {
        super();
        if (props) {
            Object.assign(this, props);
        }
        // make observable after setting properties to avoid 'strict' messages
        makeObservable(this, {
            objectId: observable, // do observe to reload when object is saved
            guid: observable,
            bfsNr: observable,
            name: observable,
            bfsName: observable,

            isAlterable: computed,

            creator: observable,
            createdAt: observable,
            editor: observable,
            updatedAt: observable,
            isNewRecord: computed
        });
    }

    get comparableAttributes(): string[] {
        return Municipality.comparableAttributes;
    }

    get isAlterable(): boolean {
        return true;
    }

    get displayLabel(): string {
        return `${this.bfsName}`;
    }

}
